import React from 'react';

import SelectInput from 'CommonComponents/SelectInput';

import SearchIcon from 'Assets/icons/search.svg';

const LAST_LOGIN_OPTIONS = () => [
    { value: 'any', label: $t('Last login: any time') },
    { value: '7d', label: $t('Last login: last 7 days') },
    { value: '30d', label: $t('Last login: last 30 days') },
    { value: 'over_30d', label: $t('Last login: over 30 days ago') },
    { value: 'never', label: $t('Last login: never') },
];

export default function UserActivityFilters({ search, roleId, lastLogin, roles, onSearchChange, onChange }) {
    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
            {/* Filled like the selects beside it, as designed, rather than the
                outlined TableSearchInput. */}
            <label className="tw-w-64 tw-h-8 tw-mb-0 tw-px-4 tw-flex tw-items-center tw-gap-x-2 tw-rounded-full tw-bg-grey/50">
                <SearchIcon className="tw-w-2.5 tw-h-2.5 tw-shrink-0 tw-text-charcoal-75" />
                <input
                    type="text"
                    className="table__search-input tw-w-full"
                    placeholder={$t('Search name or email')}
                    aria-label={$t('Search name or email')}
                    value={search}
                    onChange={(event) => onSearchChange(event.target.value)}
                />
            </label>

            <div>
                <SelectInput
                    id="user_activity_role"
                    name="user_activity_role"
                    aria-label={$t('Role')}
                    value={roleId}
                    onChange={(event) => onChange({ roleId: event.target.value })}
                >
                    <option value="">{$t('All roles')}</option>
                    {roles.map((role) => (
                        <option key={role.value} value={role.value}>
                            {$t(role.label)}
                        </option>
                    ))}
                </SelectInput>
            </div>

            <div>
                <SelectInput
                    id="user_activity_last_login"
                    name="user_activity_last_login"
                    aria-label={$t('Last login')}
                    value={lastLogin}
                    onChange={(event) => onChange({ lastLogin: event.target.value })}
                >
                    {LAST_LOGIN_OPTIONS().map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </SelectInput>
            </div>
        </div>
    );
}
